import { render, staticRenderFns } from "./StatisticsFacture.vue?vue&type=template&id=68e35061&scoped=true&"
import script from "./StatisticsFacture.vue?vue&type=script&lang=js&"
export * from "./StatisticsFacture.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsFacture.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StatisticsFacture.vue?vue&type=style&index=1&id=68e35061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e35061",
  null
  
)

export default component.exports